var _path, _circle, _path2, _g, _path3, _path4, _g2, _circle2, _g3, _path5, _g4, _path6, _g5, _path7, _g6, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g7, _path17, _g8, _path18, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyRatings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 135,
    viewBox: "0 0 208 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5994_87129)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104 158C145.421 158 179 124.421 179 83C179 41.5786 145.421 8 104 8C62.5786 8 29 41.5786 29 83C29 124.421 62.5786 158 104 158Z",
    fill: "#F6F7F9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 132.01,
    cy: 65.0099,
    r: 28.0099,
    fill: "#E8EAEE"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5994_87129)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5994_87129)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M124.232 62.7715L124.235 62.7432L124.226 62.7158C124.139 62.4189 124.049 62.0837 123.956 61.7355C123.795 61.1339 123.623 60.4934 123.436 59.9441C123.288 59.5086 123.124 59.1149 122.94 58.8301C122.762 58.5544 122.532 58.3318 122.238 58.3453C121.243 58.3906 120.485 57.7948 120.065 56.9655C119.644 56.1327 119.578 55.0892 119.953 54.2859C122.302 49.2511 126.854 46.8462 131.456 46.2794C136.067 45.7117 140.698 46.9917 143.186 49.2894C149.737 55.3385 148.787 64.1945 147.218 69.4051C143.724 81.0103 137.363 90.1479 126.317 90.1479C120.784 90.1479 116.881 87.8402 114.827 84.7706C112.771 81.6987 112.559 77.8567 114.419 74.7577C115.648 72.7097 117.355 71.4769 119.023 70.2733C119.411 69.993 119.797 69.7144 120.174 69.4273C122.169 67.9097 123.886 66.174 124.232 62.7715Z",
    fill: "white",
    stroke: "#212121",
    strokeWidth: 0.290878
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_5994_87129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.138 84.6697C151.936 86.1921 152.51 89.9711 152.86 92.9968C153.127 95.3035 151.296 97.2744 148.974 97.2744H117.622C115.3 97.2744 113.469 95.3035 113.736 92.9968C114.086 89.9711 114.66 86.1921 115.457 84.6697C117.223 81.2998 128.283 77.1332 132.046 75.7961C132.862 75.5063 133.734 75.5063 134.55 75.7961C138.313 77.1332 149.373 81.2998 151.138 84.6697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.006 84.7393C151.393 85.4785 151.732 86.7835 152.02 88.2975C152.306 89.8057 152.536 91.5029 152.711 93.0141C152.967 95.2278 151.21 97.1244 148.974 97.1244H117.622C115.386 97.1244 113.628 95.2278 113.885 93.0141C114.06 91.5029 114.29 89.8057 114.576 88.2975C114.863 86.7835 115.203 85.4785 115.59 84.7393C116.012 83.9333 117.006 83.0587 118.347 82.1748C119.683 81.2949 121.342 80.4198 123.067 79.6062C126.516 77.9794 130.217 76.6053 132.096 75.9374C132.879 75.6592 133.716 75.6592 134.499 75.9374C136.379 76.6053 140.08 77.9794 143.529 79.6062C145.254 80.4198 146.913 81.2949 148.248 82.1748C149.59 83.0587 150.583 83.9333 151.006 84.7393Z",
    stroke: "#212121",
    strokeWidth: 0.3
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M122.466 69.046C121.578 66.3772 121.36 62.6952 121.794 58.6353C122.102 58.6298 122.566 58.5885 123.16 58.2805C123.772 57.9632 124.513 57.3679 125.367 56.2562C125.375 56.9895 125.637 57.5483 126.078 57.9337C126.607 58.3964 127.373 58.5883 128.2 58.5634C129.664 58.5194 131.387 57.796 132.522 56.5594C132.238 58.1203 132.677 59.4326 133.486 60.2419C134.404 61.1598 135.786 61.4145 137.058 60.6516C138.215 59.9572 139.114 59.9829 139.747 60.3624C140.39 60.7476 140.802 61.5218 140.925 62.4076C141.049 63.2913 140.88 64.2593 140.394 65.0063C139.912 65.7477 139.113 66.2786 137.95 66.296L137.807 66.2981V66.4414V77.6012C137.797 77.6063 137.786 77.6118 137.775 77.6177C137.704 77.6542 137.6 77.7066 137.467 77.7695C137.203 77.8953 136.826 78.0633 136.379 78.2313C135.482 78.5682 134.313 78.9007 133.199 78.9007C132.087 78.9007 130.968 78.5685 130.121 78.2323C129.699 78.0646 129.348 77.8969 129.102 77.7713C128.979 77.7085 128.883 77.6563 128.817 77.6199C128.807 77.6144 128.798 77.6093 128.79 77.6045V73.4225V73.2523L128.622 73.2788C128.141 73.3548 127.654 73.3837 127.168 73.3652L127.168 73.3651H127.162C124.928 73.3649 123.364 71.7443 122.466 69.046Z",
    fill: "white",
    stroke: "#212121",
    strokeWidth: 0.290878
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M128.645 73.4223C131.05 72.9795 133.352 72.0916 135.432 70.8044C135.432 70.8044 133.008 74.9737 128.645 74.9737V73.4223Z",
    fill: "#D8D8D8"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_5994_87129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.305 78.8473C134.706 78.7839 137.953 78.0974 137.953 76.6143V75.3616C138.308 75.3616 139.327 76.2016 139.85 76.9129C141.921 79.7247 139.624 82.2457 137.751 82.2457C135.388 82.2457 133.822 80.2712 133.299 79.3214C132.775 80.2716 131.209 82.2457 128.846 82.2457C126.973 82.2457 124.677 79.7247 126.747 76.9129C127.271 76.2016 128.289 75.3616 128.645 75.3616V76.6143C128.645 78.0974 131.978 78.7839 133.305 78.8473Z",
    fill: "#E8EAEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.868 77.0019C127.12 76.6585 127.497 76.2795 127.854 75.9865C128.032 75.8402 128.203 75.7181 128.347 75.6334C128.402 75.6017 128.451 75.5761 128.495 75.5565V76.6143C128.495 77.0473 128.739 77.4067 129.091 77.6958C129.443 77.985 129.919 78.2188 130.426 78.4041C131.441 78.7747 132.621 78.9647 133.298 78.9971L133.298 78.9977L133.312 78.9971C134.026 78.9648 135.203 78.7748 136.206 78.4038C136.708 78.2185 137.175 77.9844 137.52 77.6948C137.865 77.4049 138.103 77.0457 138.103 76.6143V75.5565C138.146 75.5761 138.196 75.6017 138.25 75.6334C138.395 75.7181 138.565 75.8402 138.743 75.9865C139.101 76.2795 139.477 76.6585 139.73 77.0019C140.731 78.3626 140.668 79.6325 140.149 80.5605C139.622 81.5011 138.627 82.0957 137.751 82.0957C136.614 82.0957 135.664 81.6208 134.93 81.0234C134.195 80.4252 133.684 79.7101 133.43 79.249L133.299 79.0106L133.167 79.249C132.913 79.7103 132.402 80.4254 131.667 81.0235C130.933 81.6209 129.983 82.0957 128.846 82.0957C127.971 82.0957 126.975 81.5011 126.449 80.5605C125.929 79.6325 125.866 78.3626 126.868 77.0019ZM126.868 77.0019L126.747 76.9129M126.868 77.0019L126.747 76.9129M126.747 76.9129C127.209 76.2848 128.058 75.5562 128.495 75.3944L126.747 76.9129Z",
    stroke: "#212121",
    strokeWidth: 0.3
  }))))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.0099,
    cy: 95.0099,
    r: 28.0099,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_5994_87129)"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_5994_87129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.7415 100.801C80.3562 100.801 79.2332 101.924 79.2332 103.309C79.2332 104.695 78.1102 105.818 76.7249 105.818H71.7781C69.5645 105.818 67.7716 104.021 67.7742 101.808C67.7767 99.7173 67.7775 97.1268 67.7713 94.8419C67.7689 93.9638 67.4578 93.1222 66.98 92.3854C65.2257 89.6798 65.4328 87.8322 67.229 85.9301C68.5783 84.5012 75.4144 83.5472 79.8485 83.0679C81.9994 82.8354 83.89 84.4153 84.106 86.5679C84.4344 89.8421 84.8647 94.2678 84.9665 95.9634C85.0348 97.1011 85.7728 100.801 82.9061 100.801H81.7415Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7415 100.651C80.2734 100.651 79.0832 101.841 79.0832 103.309C79.0832 104.612 78.0273 105.668 76.7249 105.668H71.7781C69.6474 105.668 67.9217 103.939 67.9242 101.808C67.9267 99.7174 67.9275 97.1267 67.9213 94.8415C67.9188 93.928 67.5953 93.0586 67.1059 92.3038C66.2373 90.9642 65.8683 89.8579 65.9228 88.8647C65.9772 87.8745 66.4543 86.9689 67.3381 86.0331C67.647 85.7059 68.294 85.3876 69.1937 85.0899C70.085 84.7948 71.1977 84.528 72.4108 84.2901C74.8365 83.8143 77.6491 83.4565 79.8646 83.217C81.9301 82.9938 83.7489 84.5106 83.9567 86.5829C84.2853 89.8585 84.7152 94.2806 84.8168 95.9724C84.825 96.1093 84.8419 96.2772 84.861 96.4673C84.9248 97.1008 85.0133 97.9813 84.8887 98.7858C84.8083 99.3047 84.6412 99.7698 84.3363 100.104C84.0359 100.433 83.5872 100.651 82.9061 100.651H81.7415Z",
    stroke: "#212121",
    strokeWidth: 0.3
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2337 100.443C76.8999 100.188 74.6434 99.4564 72.6045 98.2927C72.6045 98.2927 73.8587 101.697 79.2337 102.772V100.443Z",
    fill: "#D8D8D8"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_5994_87129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.0993 88.1171C69.5296 87.6278 68.8373 87.2983 67.8587 87.8068C65.5386 89.0113 67.0784 93.6585 69.6747 93.5679C70.5705 93.5367 70.1599 95.3219 67.7666 96.501C67.7666 94.6197 64.8999 89.9614 64.6491 85.7202C61.7645 84.6461 62.4812 80.3484 64.4615 80.3484C64.1454 76.4083 70.4541 74.3734 72.8968 76.6343C75.3812 73.6567 81.652 75.1796 82.0306 77.7628C86.3426 75.4611 89.177 82.0775 85.1395 84.6461C83.4781 85.7032 79.5916 86.1054 73.9813 86.1054C71.2892 86.1054 72.8373 92.4067 73.6791 94.4406C74.7541 97.0385 80.7562 97.3968 82.6374 97.1281C84.1066 96.9183 84.877 96.3218 84.9666 95.9635C86.3103 99.5468 84.6082 101.697 81.9207 101.697C77.352 101.697 72.7832 100.353 72.0666 97.0385C71.4961 94.4006 71.5275 90.1434 70.0993 88.1171Z",
    fill: "#E8EAEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2112 88.0154L70.2219 88.0307C70.959 89.0765 71.3113 90.6813 71.553 92.3267C71.6436 92.9435 71.7187 93.5656 71.7918 94.1711C71.916 95.1993 72.0344 96.1799 72.2132 97.0068C72.5569 98.5966 73.827 99.7315 75.6068 100.472C77.3854 101.212 79.6485 101.547 81.9207 101.547C83.2243 101.547 84.2664 101.027 84.8269 100.097C85.3568 99.2166 85.4753 97.9377 84.932 96.3146C84.9151 96.334 84.8971 96.3532 84.8784 96.3723C84.7589 96.4938 84.5965 96.6165 84.3934 96.7319C83.9871 96.9628 83.4086 97.1695 82.6586 97.2766C81.6984 97.4137 79.71 97.3899 77.826 97.0063C76.883 96.8143 75.9579 96.5307 75.1974 96.1268C74.4382 95.7236 73.8278 95.1923 73.5405 94.4979C73.1144 93.4684 72.5127 91.3696 72.3555 89.523C72.2771 88.6018 72.3075 87.7248 72.5386 87.0717C72.6548 86.7433 72.8247 86.463 73.0654 86.2644C73.3084 86.064 73.6133 85.9554 73.9813 85.9554C76.7838 85.9554 79.151 85.8549 81.0228 85.6233C82.9003 85.391 84.2583 85.0289 85.0589 84.5195L85.1395 84.6461L85.059 84.5195C87.0041 83.2821 87.2975 81.071 86.5788 79.4385C86.2198 78.6232 85.6126 77.9638 84.8456 77.6446C84.0827 77.327 83.1442 77.3384 82.1012 77.8952L81.9131 77.9956L81.8821 77.7846C81.796 77.1968 81.3705 76.6493 80.7091 76.2023C80.0499 75.7568 79.1739 75.4239 78.2279 75.2611C76.3283 74.9341 74.2055 75.3 73.012 76.7304L72.9108 76.8516L72.7949 76.7444C72.2162 76.2087 71.4 75.9203 70.4933 75.8563C69.5873 75.7924 68.6018 75.9538 67.6991 76.3057C65.885 77.0131 64.4606 78.4618 64.611 80.3364L64.624 80.4984H64.4615C64.0268 80.4984 63.6519 80.7327 63.3716 81.124C63.0904 81.5167 62.9125 82.0587 62.8807 82.6397C62.8171 83.8018 63.3368 85.0715 64.7014 85.5796L64.793 85.6137L64.7988 85.7113C64.9227 87.8061 65.6937 90.0114 66.4417 91.9414C66.5615 92.2502 66.6808 92.5525 66.7966 92.8461C67.0412 93.4657 67.2705 94.0465 67.4561 94.569C67.687 95.219 67.8574 95.797 67.9039 96.2621C68.9538 95.7027 69.5639 95.0344 69.8194 94.5144C69.9571 94.2343 69.9825 94.0175 69.9464 93.8871C69.9294 93.8254 69.8998 93.7855 69.8629 93.7601L70.2112 88.0154ZM70.2112 88.0154L70.197 88.0033C69.9034 87.751 69.5655 87.5287 69.1643 87.4412C68.7589 87.3528 68.3055 87.4055 67.7895 87.6736C66.531 88.3271 66.3524 89.8918 66.7803 91.219C67.2087 92.5478 68.2832 93.7665 69.6799 93.7178L70.2112 88.0154Z",
    stroke: "#212121",
    strokeWidth: 0.3
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5994_87129",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 52,
    y: 103,
    width: 43,
    height: 22
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3333 106.122L66.3916 106.26L66.4734 106.226L66.4825 106.137L66.4825 106.137L66.4826 106.137L66.4827 106.136L66.4831 106.132L66.4849 106.116C66.4865 106.101 66.4889 106.08 66.4922 106.052C66.4989 105.997 66.5089 105.918 66.5225 105.822C66.5497 105.629 66.5912 105.37 66.6481 105.103C66.7052 104.835 66.7769 104.564 66.8635 104.344C66.9068 104.234 66.9523 104.141 66.9992 104.069C67.047 103.996 67.09 103.954 67.1245 103.934C67.1237 103.935 67.1233 103.935 67.1233 103.935C67.1234 103.935 67.134 103.931 67.1634 103.924C67.1947 103.917 67.2375 103.909 67.2925 103.902C67.4022 103.887 67.5514 103.872 67.7361 103.859C68.1051 103.832 68.6071 103.809 69.1993 103.791C70.3832 103.755 71.9216 103.736 73.4636 103.736C75.0057 103.736 76.5502 103.755 77.7462 103.791C78.3445 103.809 78.8542 103.832 79.2323 103.859C79.4216 103.872 79.576 103.887 79.6914 103.902C79.7491 103.91 79.7952 103.917 79.8301 103.925C79.8475 103.928 79.8609 103.932 79.8709 103.935C79.8814 103.938 79.8854 103.94 79.885 103.94C79.9826 103.986 80.085 104.121 80.1783 104.346C80.2682 104.563 80.3366 104.833 80.3876 105.1C80.4384 105.365 80.4708 105.623 80.4905 105.815C80.5003 105.911 80.5069 105.99 80.5111 106.045C80.5132 106.072 80.5146 106.093 80.5156 106.108L80.5166 106.124L80.5168 106.128L80.5169 106.129L80.5169 106.129L80.5169 106.129L80.5221 106.223L80.6083 106.259L80.6667 106.121C80.6083 106.259 80.6083 106.259 80.6084 106.259L80.6088 106.259L80.6102 106.26L80.6158 106.262L80.6382 106.272L80.726 106.309C80.8031 106.342 80.9163 106.391 81.0609 106.454C81.3501 106.579 81.7646 106.761 82.2657 106.987C83.2679 107.439 84.6155 108.065 85.9979 108.762C87.381 109.46 88.796 110.228 89.9343 110.963C90.5036 111.331 91.0009 111.689 91.3894 112.024C91.7808 112.362 92.0501 112.667 92.1779 112.926C93.2913 115.19 94.178 118.935 94.8303 124.177H52.1697C52.8222 118.935 53.7089 115.19 54.8221 112.926L54.8221 112.926C54.9502 112.666 55.2197 112.361 55.6112 112.023C55.9999 111.687 56.4973 111.329 57.0666 110.961C58.205 110.226 59.6199 109.458 61.0028 108.761C62.3852 108.064 63.7326 107.439 64.7346 106.987C65.2355 106.762 65.65 106.58 65.9391 106.454C66.0837 106.392 66.1969 106.343 66.274 106.31L66.3618 106.273L66.3842 106.263L66.3898 106.261L66.3912 106.26L66.3915 106.26C66.3916 106.26 66.3916 106.26 66.3333 106.122Z",
    fill: "#E8EAEE",
    stroke: "#212121",
    strokeWidth: 0.3
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5994_87129)"
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_5994_87129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.3125 112.86C93.4496 115.172 94.3454 118.994 95 124.327H52C52.6548 118.994 53.5506 115.172 54.6875 112.86C55.8205 110.556 66.3333 106.122 66.3333 106.122C66.3333 106.122 66.5426 104.095 67.05 103.804C67.5574 103.514 79.3457 103.514 79.95 103.804C80.5543 104.095 80.6667 106.121 80.6667 106.121C80.6667 106.121 91.1816 110.561 92.3125 112.86Z",
    fill: "#E8EAEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3333 106.122L66.3916 106.26L66.4734 106.226L66.4825 106.137L66.4825 106.137L66.4826 106.137L66.4827 106.136L66.4831 106.132L66.4849 106.116C66.4865 106.101 66.4889 106.08 66.4922 106.052C66.4989 105.997 66.5089 105.918 66.5225 105.822C66.5497 105.629 66.5912 105.37 66.6481 105.103C66.7052 104.835 66.7769 104.564 66.8635 104.344C66.9068 104.234 66.9523 104.141 66.9992 104.069C67.047 103.996 67.09 103.954 67.1245 103.934C67.1237 103.935 67.1233 103.935 67.1233 103.935C67.1234 103.935 67.134 103.931 67.1634 103.924C67.1947 103.917 67.2375 103.909 67.2925 103.902C67.4022 103.887 67.5514 103.872 67.7361 103.859C68.1051 103.832 68.6071 103.809 69.1993 103.791C70.3832 103.755 71.9216 103.736 73.4636 103.736C75.0057 103.736 76.5502 103.755 77.7462 103.791C78.3445 103.809 78.8542 103.832 79.2323 103.859C79.4216 103.872 79.576 103.887 79.6914 103.902C79.7491 103.91 79.7952 103.917 79.8301 103.925C79.8475 103.928 79.8609 103.932 79.8709 103.935C79.8814 103.938 79.8854 103.94 79.885 103.94C79.9826 103.986 80.085 104.121 80.1783 104.346C80.2682 104.563 80.3366 104.833 80.3876 105.1C80.4384 105.365 80.4708 105.623 80.4905 105.815C80.5003 105.911 80.5069 105.99 80.5111 106.045C80.5132 106.072 80.5146 106.093 80.5156 106.108L80.5166 106.124L80.5168 106.128L80.5169 106.129L80.5169 106.129L80.5169 106.129L80.5221 106.223L80.6083 106.259L80.6667 106.121C80.6083 106.259 80.6083 106.259 80.6084 106.259L80.6088 106.259L80.6102 106.26L80.6158 106.262L80.6382 106.272L80.726 106.309C80.8031 106.342 80.9163 106.391 81.0609 106.454C81.3501 106.579 81.7646 106.761 82.2657 106.987C83.2679 107.439 84.6155 108.065 85.9979 108.762C87.381 109.46 88.796 110.228 89.9343 110.963C90.5036 111.331 91.0009 111.689 91.3894 112.024C91.7808 112.362 92.0501 112.667 92.1779 112.926C93.2913 115.19 94.178 118.935 94.8303 124.177H52.1697C52.8222 118.935 53.7089 115.19 54.8221 112.926L54.8221 112.926C54.9502 112.666 55.2197 112.361 55.6112 112.023C55.9999 111.687 56.4973 111.329 57.0666 110.961C58.205 110.226 59.6199 109.458 61.0028 108.761C62.3852 108.064 63.7326 107.439 64.7346 106.987C65.2355 106.762 65.65 106.58 65.9391 106.454C66.0837 106.392 66.1969 106.343 66.274 106.31L66.3618 106.273L66.3842 106.263L66.3898 106.261L66.3912 106.26L66.3915 106.26C66.3916 106.26 66.3916 106.26 66.3333 106.122Z",
    stroke: "#212121",
    strokeWidth: 0.3
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5994_87129",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 53,
    y: 104,
    width: 41,
    height: 20
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4375 112.943C92.5217 115.172 93.3759 118.858 94 124H53C53.6243 118.857 54.4785 115.172 55.5625 112.943C56.6428 110.721 66.6667 106.445 66.6667 106.445C66.6667 106.445 66.8662 104.49 67.35 104.21C67.8338 103.93 79.0738 103.93 79.65 104.21C80.2262 104.49 80.3333 106.444 80.3333 106.444C80.3333 106.444 90.3592 110.725 91.4375 112.943Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5994_87129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.1338 121.943V120.509H97.3296V121.943H49.1338ZM49.1338 118.359V116.926H97.3296V118.359H49.1338ZM49.1338 114.776V113.343H97.3296V114.776H49.1338ZM49.1338 111.193V109.759H97.3296V111.193H49.1338Z",
    fill: "#D6DBE1"
  }))))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7625 23.1152C82.7625 23.1152 82.4051 26.6516 79.6191 26.8963C82.4051 27.141 82.7625 30.6774 82.7625 30.6774C82.7625 30.6774 83.1212 27.141 85.9071 26.8963C83.1212 26.6516 82.7625 23.1152 82.7625 23.1152Z",
    fill: "#FDC94C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3596 3.13135C47.3596 3.13135 46.9141 7.53163 43.4473 7.83597C46.9141 8.14031 47.3596 12.5406 47.3596 12.5406C47.3596 12.5406 47.8052 8.14031 51.2708 7.83597C47.8016 7.53163 47.3596 3.13135 47.3596 3.13135Z",
    fill: "#D9DDE3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.057 34.1216C23.057 34.1216 22.7269 37.3832 20.1562 37.609C22.7269 37.8348 23.057 41.0964 23.057 41.0964C23.057 41.0964 23.3871 37.8348 25.9564 37.609C23.3871 37.3832 23.057 34.1216 23.057 34.1216Z",
    fill: "#EDEBF9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.057 34.1216C23.057 34.1216 22.7269 37.3832 20.1562 37.609C22.7269 37.8348 23.057 41.0964 23.057 41.0964C23.057 41.0964 23.3871 37.8348 25.9564 37.609C23.3871 37.3832 23.057 34.1216 23.057 34.1216Z",
    fill: "#D9DDE3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M193.46 89.6328C193.46 89.6328 193.014 94.0331 189.549 94.3374C193.014 94.6418 193.46 99.0421 193.46 99.0421C193.46 99.0421 193.906 94.6418 197.372 94.3374C193.906 94.0331 193.46 89.6328 193.46 89.6328Z",
    fill: "#EDEBF9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91238 59.126C9.91238 59.126 9.46686 63.5263 6 63.8306C9.46686 64.1349 9.91238 68.5352 9.91238 68.5352C9.91238 68.5352 10.3567 64.1349 13.8236 63.8306C10.3567 63.5263 9.91238 59.126 9.91238 59.126Z",
    fill: "#FDC94C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M198.752 54.4219C198.752 54.4219 198.307 58.8222 194.84 59.1265C198.307 59.4308 198.752 63.8311 198.752 63.8311C198.752 63.8311 199.198 59.4308 202.663 59.1265C199.195 58.8222 198.752 54.4219 198.752 54.4219Z",
    fill: "#FDC94C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M117.595 4C117.595 4 117.149 8.40028 113.684 8.70462C117.149 9.00896 117.595 13.4092 117.595 13.4092C117.595 13.4092 118.04 9.00896 121.507 8.70462C118.04 8.40028 117.595 4 117.595 4Z",
    fill: "#D9DDE3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M175.956 29.937C175.956 29.937 175.686 33.0592 173.566 33.2755C175.684 33.4919 175.956 36.6154 175.956 36.6154C175.956 36.6154 176.226 33.4919 178.346 33.2755C176.228 33.0592 175.956 29.937 175.956 29.937Z",
    fill: "#D9DDE3"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_5994_87129)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 102,
    width: 20,
    height: 20,
    rx: 4,
    fill: "#EC4E7C"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M94.832 115.843C96.236 114.881 97.3583 113.941 98.199 113.022C99.0483 112.095 99.473 111.237 99.473 110.448C99.473 109.98 99.356 109.607 99.122 109.33C98.8967 109.053 98.5283 108.914 98.017 108.914C97.4883 108.914 97.0897 109.087 96.821 109.434C96.5523 109.772 96.4007 110.257 96.366 110.89H94.923C94.9837 109.841 95.3043 109.04 95.885 108.485C96.4743 107.93 97.224 107.653 98.134 107.653C99.0267 107.653 99.7243 107.891 100.227 108.368C100.738 108.836 100.994 109.486 100.994 110.318C100.994 110.985 100.786 111.661 100.37 112.346C99.9627 113.031 99.4427 113.663 98.81 114.244C98.1773 114.816 97.523 115.31 96.847 115.726H101.202V116.935H94.832V115.843Z",
    fill: "white"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_5994_87129)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 72,
    width: 20,
    height: 20,
    rx: 4,
    fill: "#5BCBC9"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M152.977 78.992H148.44V81.722C148.648 81.4533 148.943 81.241 149.324 81.085C149.705 80.9203 150.126 80.838 150.585 80.838C151.226 80.838 151.759 80.9767 152.184 81.254C152.609 81.5227 152.921 81.8823 153.12 82.333C153.328 82.7837 153.432 83.282 153.432 83.828C153.432 84.79 153.163 85.57 152.626 86.168C152.089 86.7573 151.309 87.052 150.286 87.052C149.324 87.052 148.548 86.7963 147.959 86.285C147.37 85.7737 147.049 85.0933 146.997 84.244H148.453C148.531 84.712 148.722 85.0803 149.025 85.349C149.337 85.6177 149.731 85.752 150.208 85.752C150.797 85.752 151.239 85.5743 151.534 85.219C151.829 84.8637 151.976 84.3913 151.976 83.802C151.976 83.2473 151.824 82.814 151.521 82.502C151.218 82.1813 150.784 82.021 150.221 82.021C149.822 82.021 149.471 82.1077 149.168 82.281C148.873 82.4543 148.657 82.684 148.518 82.97H147.075V77.679H152.977V78.992Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5994_87129",
    x: 107,
    y: 36,
    width: 59.8857,
    height: 71.2744,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5994_87129"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5994_87129",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_5994_87129",
    x: 107.71,
    y: 65.5786,
    width: 59.1758,
    height: 41.6958,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5994_87129"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5994_87129",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_5994_87129",
    x: 119.93,
    y: 65.3616,
    width: 34.7373,
    height: 26.884,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5994_87129"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5994_87129",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_5994_87129",
    x: 59.7676,
    y: 73.0452,
    width: 39.334,
    height: 42.7725,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5994_87129"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5994_87129",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_5994_87129",
    x: 56.7256,
    y: 65,
    width: 44.3613,
    height: 46.6968,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5994_87129"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5994_87129",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_5994_87129",
    x: 46,
    y: 93.5864,
    width: 63,
    height: 40.7405,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5994_87129"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5994_87129",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_5994_87129",
    x: 88,
    y: 98,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5994_87129"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5994_87129",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_5994_87129",
    x: 140,
    y: 68,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5994_87129"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5994_87129",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5994_87129"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 208,
    height: 135,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5994_87129"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 37,
    width: 57,
    height: 56,
    rx: 28,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_5994_87129"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 67,
    width: 56,
    height: 56,
    rx: 28,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyRatings);
export default __webpack_public_path__ + "static/media/empty-ratings.ffd539b4.svg";
export { ForwardRef as ReactComponent };